/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const userUiPreferences = sqliteTable('user_ui_preferences', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  user_id: text('user_id'),
  preference_key: text('preference_key'),
  value_json: text('value_json'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
